import { render, staticRenderFns } from "./AdvMinicartGiftChoiceModal.vue?vue&type=template&id=260a7b88"
import script from "./AdvMinicartGiftChoiceModal.vue?vue&type=script&lang=js"
export * from "./AdvMinicartGiftChoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports